<template>
  <div class="single-poi" @click="showSinglePOI" @mouseover="mouseover" @mouseleave="mouseleave">
    <div v-if="item.cover || item.parent.image" class="single-poi-img">
      <img
        class="cover-img"
        :src="hostAddress + (item.cover || item.parent.image)"
        alt=""
        :style="getCoverBackground(item)"
      />
      <div class="is-opened-info" v-if="item.opening_hours" :class="{opened: isOpened}">
        <i class="material-icons-round md-12 white">schedule</i>
        {{ isOpened ? $t("poiDetails.opened") : $t("poiDetails.closed") }}
      </div>
    </div>
    <div v-else class="single-poi-img"><img class="cover-img" src="/images/placeholder.png" alt="" /></div>
    <div class="single-poi-data">
      <p class="single-poi-name">{{ item.name }}</p>
      <p class="single-poi-address" v-if="item.address">
        {{ item.address[0] }}
      </p>
      <p class="single-poi-address" v-if="item.address">
        {{ item.address[1] }}
      </p>
      <div class="single-poi-category">
        <!-- <img class="single-poi-category-logo" :src="hostAddress + item.parent.logo" v-if="item.parent.logo" /> -->
        <div class="single-poi-category-name">{{ cleanParentName }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import CategoryService from "@/services/category";
import M2wApi from "@/services/m2w_api";
// import convertPoisToGeoJSON from "@/convertPoisToGeoJSON";

export default {
  name: "PoiTocCard",
  data() {
    return {
      hostAddress: M2wApi.host_address,
    };
  },
  props: {
    item: Object,
  },
  computed: {
    isOpened: function () {
      return CategoryService.checkIfOpened(this.item, true);
    },
    cleanParentName() {
      return this.stripSoftHyphens(this.item?.parent?.name);
    },
  },

  methods: {
    stripSoftHyphens(text) {
      if (!text) return "";
      return text.replace(/&shy;|\u00AD/g, "");
    },
    // async showSinglePOI() {
    //   const enrichedItem = {
    //     ...this.item,
    //     icon: this.item.icon || this.item.marker || this.item.parent?.marker || null,
    //     icon_id: this.item.icon_id || this.item.marker || this.item.parent?.marker || null,
    //     color: this.item.color || "#0000ff",
    //     width: this.item.width || this.item.line_thickness || 2,
    //     fill_color: this.item.fill_color || this.item.parent?.style?.fill_color || "#ff0000",
    //     fill_opacity: this.item.fill_opacity ?? 0.5,
    //     line_color: this.item.line_color || this.item.color || "#0000ff",
    //   };

    //   const geojson = convertPoisToGeoJSON([enrichedItem]);

    //   if (geojson?.features?.length) {
    //     this.$root.$emit("poiSelectedFromList", geojson.features[0]);
    //   } else {
    //     console.warn("Failed to convert POI:", enrichedItem);
    //   }

    //   await this.$router.push({
    //     name: "poiDetails",
    //     params: {id: this.item.id},
    //     query: {parent: this.item.parent.id},
    //   });
    // },
async showSinglePOI() {
  try {
    await this.$router.push({
      name: "poiDetails",
      params: {
        id: String(this.item.id),
      },
      query: {
        ...this.$route.query,
        parent: String(this.item.parent.id),
      },
    });
  } catch (error) {
    if (error?.name !== "NavigationDuplicated") {
      console.error("[PoiTocCard] Nu s-a putut deschide POI-ul:", error);
    }
  }
},
    mouseover() {
      //basemap.setCircleMarkerStyle(this.item);
    },
    mouseleave() {
      //basemap.deleteOverlayMarker(this.item);
    },
    getCoverBackground() {
      if (this.item.parent.style && this.item.parent.style.fill_color) {
        return {"background-color": this.item.parent.style.fill_color};
      }
      return "";
    },
  },
};
</script>
